import { QueryKey, useQuery, UseQueryOptions } from 'react-query'

import api from 'api/index'
import { ApiError } from 'api/types/ApiError'
import { CheckupLogDetails } from 'types/domain/CheckupLog'

import { CHECKUP_LOGS_ENDPOINT_KEY } from './constants'

type GetCheckupResourceRequestParams = {
  id: number
}

type GetCheckupResourceResponse = {
  data: CheckupLogDetails
}

export const getCheckupResource = ({
  params,
}: {
  params: GetCheckupResourceRequestParams
}): Promise<GetCheckupResourceResponse> => api.get(`/${CHECKUP_LOGS_ENDPOINT_KEY}/${params.id}`)

export const useGetCheckupResource = ({
  params,
  queryOptions,
  customQueryKey,
}: {
  params: GetCheckupResourceRequestParams
  queryOptions?: UseQueryOptions<Awaited<ReturnType<typeof getCheckupResource>>, ApiError>
  customQueryKey?: QueryKey
}) =>
  useQuery(
    customQueryKey || [CHECKUP_LOGS_ENDPOINT_KEY, 'details', ...Object.values(params || {})],
    () => getCheckupResource({ params }),
    queryOptions,
  )
